import styled from 'styled-components';
export const Form = styled.form `
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 2.4rem auto 0;
  flex-direction: column;

  ${({ theme }) => theme.media.tablet `
    margin-left: 0rem;
  `};
`;
export const InputContainer = styled.div `
  width: 100%;
  margin-bottom: ${({ isLast }) => (isLast ? 0 : '2.4rem')};
`;
export const ButtonWrapper = styled.div `
  width: 100%;
  margin-top: 0.2rem;
`;
export const LinkWrapper = styled.div `
  width: 100%;
  margin-bottom: 2rem;
`;
export const ErrorMessageWrapper = styled.div `
  width: 100%;
  height: 2rem;
  margin-top: 0.4rem;
`;
//# sourceMappingURL=styles.js.map